//TO-DO slimdown  /src/features/utilities.ts to avoid circular dependency issue
import { equals, filter, pathOr, replace, toLower, toString } from "ramda";

//used for creating unique id

export const generateUniqueID = () => replace('.', '7', toString(new Date().valueOf() + performance.now()));


//used for filtering intent questions based on their subproduct type
export const filterBySubProduct = (subProducts: any, key: string, subProductName: any) => {
  return filter((subproduct: any) => {
    return equals(toLower(pathOr("", [key], subproduct)), toLower(subProductName))
  }, subProducts)
}
